/** IF02095 でタスク画面を再取得しローカルストアへ反映する（一括操作・モーダル成功後の同期用）。 */
import { fetchGenericTaskScreen } from './services'
import { ACTION_TYPES } from './store'

/**
 * @param {{ getState?: () => unknown }} reduxStore グローバル Redux（corporation_resources 解決用）
 * @param {(type: string, payload?: unknown) => void} reportDispatch
 * @param {string | number | null | undefined} taskKey
 * @returns {Promise<void>}
 */
export async function refreshReportTaskScreen(reduxStore, reportDispatch, taskKey) {
  if (taskKey === null || taskKey === undefined || taskKey === '') {
    return
  }
  const screen = await fetchGenericTaskScreen(reduxStore, taskKey)
  reportDispatch(ACTION_TYPES.REFRESH_TASK, screen)
}
